"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultEmailTemplate = exports.isAppealFormCategory = void 0;
const enums_1 = require("../enums");
const APPEAL_FORM_CATEGORIES = [
    enums_1.FormCategory.DonationForm,
    enums_1.FormCategory.PeerToPeerCampaign,
    enums_1.FormCategory.MembershipV2,
    enums_1.FormCategory.Shop,
];
const isAppealFormCategory = (formCategory) => Boolean(formCategory && APPEAL_FORM_CATEGORIES.includes(formCategory));
exports.isAppealFormCategory = isAppealFormCategory;
const getDefaultEmailTemplateKey = ({ emailType, formType, formCategory, }) => {
    switch (emailType) {
        case enums_1.EmailContentType.INVITATION:
            return (0, exports.isAppealFormCategory)(formCategory) ? "fundraising" : "invitation";
        case enums_1.EmailContentType.REMINDER:
            if (formCategory === enums_1.FormCategory.Auction) {
                return "auctionReminder";
            }
            return "eventReminder";
        case enums_1.EmailContentType.FOLLOW_UP: {
            if (formType === enums_1.FormType.Ticketing) {
                return "ticketingFollowUp";
            }
            if (formType === enums_1.FormType.DonationForm) {
                return "donationFormFollowUp";
            }
            break;
        }
        case enums_1.EmailContentType.POST_EVENT:
            return "eventRecap";
        default:
            return undefined;
    }
    return undefined;
};
const getDefaultEmailTemplate = ({ emailType, formType, formCategory, }) => {
    return {
        templateKey: getDefaultEmailTemplateKey({ emailType, formType, formCategory }) ?? undefined,
    };
};
exports.getDefaultEmailTemplate = getDefaultEmailTemplate;
